import { render, staticRenderFns } from "./CopySettings.vue?vue&type=template&id=ba691264&"
import script from "./CopySettings.vue?vue&type=script&lang=js&"
export * from "./CopySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports